import * as launchDarkly from 'app-lib/launch-darkly/launch-darkly';
import { appLogger } from 'app-lib/helpers/logging';
const logger = appLogger.create('Search Launch Darkly');
const FEATURE_SEARCH = 'feature-search';

export function subscribeForFeatureSearch(listeners) {
    if (!listeners) {
        logger.error('Cannot subscribe for feature search without listeners');
        return;
    }
    launchDarkly.subscribeForFeatureFlagChange(FEATURE_SEARCH, listeners);
}

export function isSearchEnabled() {
    return launchDarkly.getVariation(FEATURE_SEARCH, true);
}



// WEBPACK FOOTER //
// ./src/app-lib/launch-darkly/search/search-launch-darkly.js